import { FC } from 'react';
import { Badge, BadgeProps } from '@kontentino/ui';
import clsx from 'clsx';

const PendingBadge: FC<Omit<BadgeProps, 'variant'>> = ({
  className,
  ...props
}) => (
  <Badge
    className={clsx('tw-bg-warning-20 tw-text-warning-120', className)}
    {...props}
  />
);

export default PendingBadge;
